export const LoadBetErrors = {
  Default: "Sorry, we're unable to create bet",
  BettingClosed: 'Sorry, betting is closed',
} as const

export function getLoadBetErrorMessage(error: unknown): string {
  return isErrorInstance(error) && error.message === LoadBetErrors.BettingClosed
    ? LoadBetErrors.BettingClosed
    : LoadBetErrors.Default
}

// =============
// Local Helpers
// =============

const isErrorInstance = (error: unknown): error is Error => error instanceof Error
